<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col>
        <b-card>
          <div slot="header">
            <i class="fa fa-edit"></i> {{ $t('str.manage-country') }}
            <div class="card-header-actions">
              <router-link to="/office/country" class="card-header-action btn-setting">
                <buttons button-type="back" />
              </router-link>
            </div>
          </div>
          <b-form @submit.prevent="saveData">
            <b-row>
              <b-col sm="12">
                <table class="table">
                  <tbody>
                    <tr>
                      <th scope="row">{{$t('str.name')}}</th>
                      <td>
                        <b-form-input type="text" name="name"
                          :class="{ 'form-control': true, 'is-invalid': errors.has('name') }" id="name"
                          v-validate="{ required: true }" v-model="addData.name" />
                        <span class="invalid-feedback">{{ errors.first('name') }}</span>
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">{{$t('str.country-code')}}</th>
                      <td>
                        <b-form-input type="text" name="code"
                          :class="{ 'form-control': true, 'is-invalid': errors.has('code') }" id="code"
                          v-validate="{ required: true }" v-model="addData.code" />
                        <span class="invalid-feedback">{{ errors.first('code') }}</span>
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">{{$t('str.phone-code')}}</th>
                      <td>
                        <b-input-group>
                          <b-input-group-prepend>
                            <b-input-group-text>+</b-input-group-text>
                          </b-input-group-prepend>
                          <b-form-input type="number" name="phone_code"
                            :class="{ 'form-control': true, 'is-invalid': errors.has('phone_code') }" id="phone_code"
                            v-validate="{ required: true }" v-model="addData.phone_code" />
                        </b-input-group>
                        <span class="invalid-feedback">{{ errors.first('phone_code') }}</span>
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">{{$t('str.text-orientation')}}</th>
                      <td>
                        <b-row class="form-group">
                          <b-col md="2" cols="2" class="text-right">{{$t('str.left-to-right')}}</b-col>
                          <b-col md="1" cols="1">
                            <c-switch class="mx-1" color="primary" variant="pill" v-model="temp_is_right_to_left" />
                          </b-col>
                          <b-col md="2" cols="2">{{$t('str.right-to-left')}}</b-col>
                        </b-row>
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">{{$t('str.office')}}</th>
                      <td>
                        <b-input-group>
                          <b-form-select name="office_id" v-model="addData.office_id">
                            <option :value="null">-</option>
                            <option v-for="(cat, i) in officeSelect" :value="cat.id" :key="i">{{cat.name}}</option>
                          </b-form-select>
                        </b-input-group>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="6">
                <buttons button-type="submit" />
              </b-col>
            </b-row>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import axios from 'axios'

import { Switch as cSwitch } from '@coreui/vue'
import Buttons from '@/views/component/Buttons'

export default {
  components: {
    'buttons': Buttons,
    cSwitch
  },
  data() {
    return {
      id: this.$route.params.id,
      officeSelect: {},
      addData: {
        name: '',
        code: '',
        phone_code: '',
        office_id: '',
        is_right_to_left: 0,
      },
      temp_is_right_to_left: false,
    }
  },
  methods: {
    async getOfficeSelect() {
      this.$auth.checkSession()
      try {
        let getData = await axios.get(`${this.$helper.envi.VUE_APP_API_URL}/Office`, {
          headers: { 'Authorization': `Bearer ${this.$auth.session.get().passport}` }
        })
        this.officeSelect = getData.data.data
      } catch (e) {
        console.log(e.response)
      }
    },
    async getData() {
      this.$auth.checkSession()
      let countryId = this.id

      if (countryId > 0) {
        try {
          let getData = await axios.get(`${this.$helper.envi.VUE_APP_API_URL}/Country/${countryId}`, {
            headers: { 'Authorization': `Bearer ${this.$auth.session.get().passport}` }
          })

          this.addData.name = getData.data.data.name
          this.addData.code = getData.data.data.code
          this.addData.phone_code = parseInt(getData.data.data.phone_code)
          this.addData.office_id = getData.data.data.office_id

          /* parsing int to boolean */
          this.temp_is_right_to_left = Boolean(getData.data.data.is_right_to_left)
        } catch (e) {
          console.log('err', e.response)
          if (e.response) {
            this.$router.push('/pages/404')
          }
        }
      }
    },
    async saveData() {
      this.$auth.checkSession()
      if (this.$validator.validateAll()) {
        let method = 'post'
        let url = `${this.$helper.envi.VUE_APP_API_URL}/Country/`

        if (this.id > 0) {
          method = 'patch'
          url = `${url}${this.id}`
        }

        this.addData.is_right_to_left = this.temp_is_right_to_left ? 1 : 0

        try {
          var result = await axios[method](url, this.addData, {
            headers: { 'Authorization': `Bearer ${this.$auth.session.get().passport}` }
          })

          this.$toast.success(result.data.meta.message, '', {
            position: 'topCenter'
          })

          if (this.id == 0)
            this.$router.push('/office/country')
        } catch (e) {
          if (Array.isArray(e.response.data.meta.error)) {
            e.response.data.meta.error.forEach((err) => {
              this.$toast.error(err.msg, e.response.data.meta.message, {
                position: 'topCenter'
              })
            })
          } else if (typeof e.response.data.meta.error === 'string') {
            this.$toast.error(e.response.data.meta.message, e.response.data.meta.error, {
              position: 'topCenter'
            })
          }
        }
      }
    }
  },
  created() {
    this.getOfficeSelect()
    this.getData()
  },
}
</script>